import { render, staticRenderFns } from "./accommodations.vue?vue&type=template&id=2f14f4f6&scoped=true&"
import script from "./accommodations.vue?vue&type=script&lang=js&"
export * from "./accommodations.vue?vue&type=script&lang=js&"
import style0 from "./accommodations.vue?vue&type=style&index=0&id=2f14f4f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14f4f6",
  null
  
)

export default component.exports